// Page navigation — ported from the original app's NAV section. Pages register their
// render function here (via registerPage) instead of goNav() hardcoding a big if/else
// chain that would need to import every page module directly (which would tangle into
// circular imports, since several pages need to trigger a re-render of another page —
// e.g. saving food today also refreshes Home).
import { IC } from './icons.js';
import { openSheet } from './modal.js';

export const PAGES = ['home', 'food', 'workout', 'vitamins', 'dishes', 'archive', 'measurements', 'settings'];
export const NAV_VISIBLE = ['home', 'food', 'workout', 'vitamins']; // shown directly in the bottom bar
export const MORE_PAGES = ['archive', 'measurements', 'settings']; // behind "Ещё"
export const NAV_LABELS_MAP = { home: 'Главная', food: 'Питание', workout: 'Тренировки', vitamins: 'Витамины', dishes: 'Блюда', archive: 'Архив', measurements: 'Замеры', settings: 'Настройки' };
export const NAV_ICONS_MAP = { home: 'home', food: 'food', workout: 'workout', vitamins: 'vitamins', dishes: 'dishes', archive: 'archive', measurements: 'ruler', settings: 'settings' };

export let curPage = 'home';

const registry = {};
export function registerPage(name, renderFn) { registry[name] = renderFn; }

export function buildNav() {
  const nav = document.getElementById('nav');
  let html = `<div class="liquid-pill" id="navPill"></div>`;
  html += NAV_VISIBLE.map(p => `
    <button onclick="goNav('${p}')" id="nav_${p}" class="${p === curPage ? 'active' : ''}">
      ${IC[NAV_ICONS_MAP[p]]}
      <span>${NAV_LABELS_MAP[p]}</span>
    </button>
  `).join('');
  html += `
    <button onclick="openMoreMenu()" id="nav_more" class="${MORE_PAGES.includes(curPage) ? 'active' : ''}">
      ${IC.more}
      <span>Ещё</span>
    </button>`;
  nav.innerHTML = html;
  moveNavPill(true);
  window.addEventListener('resize', () => moveNavPill(true));
}

// Liquid-glass pill that slides/resizes to sit behind whichever tab is active — see
// style/nav.css .liquid-pill. `instant` skips the transition (first paint, resize).
function moveNavPill(instant) {
  const nav = document.getElementById('nav');
  const pill = document.getElementById('navPill');
  const active = nav?.querySelector('button.active');
  if (!nav || !pill || !active) return;
  const navRect = nav.getBoundingClientRect();
  const r = active.getBoundingClientRect();
  if (instant) pill.style.transition = 'none';
  pill.style.left = (r.left - navRect.left + 6) + 'px';
  pill.style.width = (r.width - 12) + 'px';
  if (instant) requestAnimationFrame(() => { pill.style.transition = ''; });
}

export function openMoreMenu() {
  document.getElementById('moreMenuBody').innerHTML = MORE_PAGES.map(p => `
    <button class="more-menu-item" onclick="closeSheet('shMoreMenu');goNav('${p}')">
      ${IC[NAV_ICONS_MAP[p]]}
      <span>${NAV_LABELS_MAP[p]}</span>
      ${IC.chev_r}
    </button>
  `).join('');
  openSheet('shMoreMenu');
}

export function goNav(p) {
  curPage = p;
  PAGES.forEach(x => {
    document.getElementById('p-' + x)?.classList.toggle('active', x === p);
  });
  // "Блюда" is conceptually a sub-page of "Питание" — keep the Питание tab lit while there.
  NAV_VISIBLE.forEach(x => {
    const nb = document.getElementById('nav_' + x);
    if (nb) nb.classList.toggle('active', x === p || (x === 'food' && p === 'dishes'));
  });
  const moreBtn = document.getElementById('nav_more');
  if (moreBtn) moreBtn.classList.toggle('active', MORE_PAGES.includes(p));
  moveNavPill(false);
  const renderFn = registry[p];
  if (renderFn) renderFn();
}

/** Re-renders whichever page is currently open — used after data arrives from Firestore. */
export function renderAll() {
  const renderFn = registry[curPage];
  if (renderFn) renderFn();
}
